import axios, { AxiosError } from "axios";

import VideoDTO from "../Models/DTOs/VideoDTO";
import SeriesDTO from "../Models/DTOs/SeriesDTO";
import ArticleDTO from "../Models/DTOs/ArticleDTO";

const SEARCH_API_URL = process.env.REACT_APP_SEARCH_API_URL;

export type SearchItemDTO = (VideoDTO | SeriesDTO | ArticleDTO) & {
    DataType: "Film" | "Episode" | "Series" | "Article";
};

export interface SearchResultsDTO {
    items: SearchItemDTO[];
    total: number;
}

export async function GetSearchResults(
    searchTerm: string,
    types: string[],
    excludeEpisodes: boolean,
    take: number,
    skip: number,
    abortController: AbortController
) {
    if (!searchTerm) return null;

    // Build the query parameters safely
    const params = new URLSearchParams({
        q: searchTerm,
        take: take.toString(),
        skip: skip.toString()
    });

    if (types.length > 0) {
        params.append("types", types.join(","));
    }

    if (excludeEpisodes) {
        params.append("excludeEpisodes", "true");
    }

    return await axios
        .get(`${SEARCH_API_URL}v1/search?${params.toString()}`, {
            signal: abortController.signal
        })
        .then((result) => result.data as SearchResultsDTO)
        .catch((error: AxiosError) => {
            if ((error as any)?.name === "CanceledError") throw error;
            console.error("GetSearchResults error", error);
            throw error;
        });
}
